import BaseEntity from '../../base/BaseEntity.model';

export default class TramiteAplicacionNominaModel extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public errorEnMonto: boolean;
    public comentario?: string;
    constructor(public nominaId: number | undefined = undefined) {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.errorEnMonto = true;
        this.comentario = undefined;
    }
}

export class AplicacionNominaModel{
    public descripcion:string;
    public telefono:string;
    public nominas: TramiteAplicacionNominaModel[];
    constructor(){
        this.descripcion = '';
        this.telefono = '';
        this.nominas = [];
    }
}